import { currencySymbol } from "pages/price/PriceWithCurrency";

const PriceView = ({ currency, price, targetCurrency, exchangeRate }) => {
  const hasDifferenceCurrency = currency !== targetCurrency;

  console.log("exchangeRate", exchangeRate);

  return (
    <div>
      {currencySymbol(currency)} {price}
      {hasDifferenceCurrency ? (
        <span>
          {" "}
          → {currencySymbol(targetCurrency)} {(price / exchangeRate).toFixed(3)}
        </span>
      ) : null}
    </div>
  );
};

export default PriceView;
